<div class="overlay" *ngIf="isBusy">
    <div class="overlay-content">
        <img src="assets/images/ajax-loading2.gif" alt="loading" class="loading-indicator"/>
    </div>
</div> 
